(function ($) {
// run on DOM ready
// grab target from URL hash (i.e. www.example.com/page-a.html#target-name)
	$(document).ready(function () {
// your code
		let target = window.location.hash;
		const header = $(".main-menu");
		let headerHeight = header.position().top + header.outerHeight(true) + 10;
// only try to scroll to offset if target has been set in location hash
		console.log("scrolling to : " + target, headerHeight);
		if (target != '') {
			let $target = $(target);
			console.log($target);
			$('html, body').animate({
					'scrollTop': $target.offset().top - headerHeight
				}, // set offset value here i.e. 50
				500,
				'swing');
		}
	});
})(jQuery);
